import React from 'react';
import BrandingFooter from './BrandingFooter';
import MatchRowTeams from './MatchRowTeams';
import { parseScorePair } from './matchWidgetUtils';

function StatusBadge({ match }) {
  if (match.live) {
    return <span className="sw-status-badge sw-status-live">LIVE</span>;
  }
  if (match.upcoming) {
    return <span className="sw-status-badge sw-status-upcoming">Soon</span>;
  }
  return <span className="sw-status-badge sw-status-ft">FT</span>;
}

function MatchCardRow({ match, teamLayout = 'inline' }) {
  const { home, away } = parseScorePair(match.score);
  const showScore = home != null && away != null && !match.upcoming;

  return (
    <div className={`sw-match-card w-full ${match.live ? 'sw-match-card--live' : ''}`}>
      <div className="flex items-center justify-between gap-3 mb-2">
        <StatusBadge match={match} />
        {match.minute && match.live && (
          <span className="text-[10px] font-mono font-bold text-red-400">{match.minute}</span>
        )}
      </div>
      <div className="flex items-center justify-between gap-4 w-full">
        <MatchRowTeams match={match} size={28} layout={teamLayout} />
        <div className="text-right shrink-0">
          {showScore ? (
            <p className="text-xl font-black tabular-nums tracking-tight">
              {home}
              <span className="mx-1 opacity-40">:</span>
              {away}
            </p>
          ) : (
            <p className="text-sm font-bold tabular-nums whitespace-nowrap" style={{ color: 'var(--sw-muted)' }}>
              {match.score}
            </p>
          )}
        </div>
      </div>
      {match.venue && (
        <p className="text-[10px] mt-2" style={{ color: 'var(--sw-muted)' }}>
          📍 {match.venue}
        </p>
      )}
      {match.ht?.label && (
        <p className="text-[10px] mt-1" style={{ color: 'var(--sw-muted)' }}>
          HT {match.ht.label}
        </p>
      )}
      {match.events?.length > 0 && (
        <p className="text-[10px] mt-1 font-semibold" style={{ color: 'var(--sw-accent)' }}>
          {match.events.length} events
        </p>
      )}
    </div>
  );
}

export default function MatchList({
  showBranding = false,
  competitionLabel = 'Premier League',
  subtitle = '',
  matches = [],
  emptyMessage = 'No matches available.',
  teamLayout = 'inline',
}) {
  const header = subtitle ? `${competitionLabel}` : competitionLabel;

  return (
    <div className="sw-match-widget w-full min-w-0" style={{ background: 'var(--sw-bg)', color: 'var(--sw-text)' }}>
      <div className="sw-match-header px-4 py-2.5 border-b w-full" style={{ borderColor: 'var(--sw-border)' }}>
        <p className="text-[10px] font-bold uppercase tracking-widest" style={{ color: 'var(--sw-accent)' }}>
          {header}
        </p>
        {subtitle && (
          <p className="text-xs font-semibold mt-0.5">{subtitle}</p>
        )}
      </div>
      <div className="p-4 space-y-3 w-full">
        {matches.map((m, i) => (
          <MatchCardRow key={`${m.matchId || m.home}-${m.away}-${i}`} match={m} teamLayout={teamLayout} />
        ))}
        {!matches.length && (
          <p className="text-center text-xs py-8" style={{ color: 'var(--sw-muted)' }}>
            {emptyMessage}
          </p>
        )}
      </div>
      {showBranding && <BrandingFooter />}
    </div>
  );
}
